import { createFileRoute } from "@tanstack/react-router";
import { ProposalAnalyticsPage } from "@/features/proposalstats/ProposalAnalyticsPage";

export const Route = createFileRoute("/_app/proposals/$proposal/analytics")({ component: Page });

function Page() {
  const { proposal } = Route.useParams();
  return <ProposalAnalyticsPage id={proposal} />;
}
